import { genComponentEl } from '@/utils/utils';
import Component from './component.vue';

/**
 * 设置MN606设备报警阈值
 *
 * @param {Object} data
 */
export function openMN606SensorsAlarmThresholdDialog(data) {
  genComponentEl(Component, data);
}
